import React from 'react';
import { Link } from 'lucide-react';
import CustomButton from './CustomButton';
import saurinImage from '../images/saurin.jpg';
import aashishImage from '../images/aashish.jpg';



const TeamMember = ({ name, role, description, imageUrl, linkedInUrl }) => (
    <div className="bg-white p-6 rounded-tr-3xl rounded-bl-3xl shadow-lg hover:shadow-xl transition-shadow duration-300">
      <div className="flex flex-col md:flex-row items-center gap-6 mb-4">
        <div className="w-32 h-32 rounded-full overflow-hidden shrink-0">
          <img 
            src={imageUrl} 
            alt={name} 
            className="w-full h-full object-cover"
          />
        </div>
        <div className="flex-1 text-center md:text-left">
          <div className="flex items-center justify-center md:justify-start gap-3 mb-2">
            <h3 className="text-xl font-bold text-[#003B5C]">{name}</h3>
            <a 
              href={linkedInUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="text-[#0077b5] hover:text-[#004d77] transition-colors"
              aria-label={`${name}'s LinkedIn profile`}
            >
              <Link className="w-5 h-5" />
            </a>
          </div>
          <p className="text-[#8b123b] font-medium mb-3">{role}</p>
          <p className="text-gray-600 text-sm">{description}</p>
        </div>
      </div>
    </div>
  );
  
  const AboutUs = () => {
    return (
      <div className="min-h-screen bg-gray-50">  
      <div className="max-w-7xl mx-auto px-4 py-32">
        {/* Company Overview */}
        <div className="text-center mb-24">
          <p className="text-lg text-gray-700 max-w-3xl font-italic mx-auto">
            At Novecta Solutions, we believe in creating value through dual streams of excellence - strategic consulting and responsible innovation. Our approach uniquely positions us to serve both businesses and end consumers while maintaining the highest standards of business ethics.
          </p>
        </div>

        {/* Expertise Sections */}
        <div className="mb-24 bg-[#f1958b] rounded-tr-[40px] rounded-bl-[40px] shadow-lg p-8 md:p-12">
          <h2 className="text-3xl font-bold text-[#003B5C] mb-12 text-center">Our Expertise</h2>
          
          {/* Consulting Section */}
          <div className="mb-12 bg-[#e0dcdc] rounded-tr-[30px] rounded-bl-[30px] p-6 md:p-8">
            <h3 className="text-xl font-bold text-[#003B5C] mb-4">Consulting by Novecta</h3>
            <p className="text-lg text-gray-700">
              Drawing from our 36 years of combined leadership experience across Banking, NBFC, and Fintech sectors, we help businesses optimize their credit operations, enhance distribution channels, and implement effective monetization strategies. Our consulting practice is built on deep industry knowledge and a commitment to delivering measurable results for our clients.
            </p>
          </div>

          {/* Innovation Section */}
          <div className="bg-[#e0dcdc] rounded-tr-[30px] rounded-bl-[30px] p-6 md:p-8">
            <h3 className="text-xl font-bold text-[#003B5C] mb-4">Innovations by Novecta</h3>
            <p className="text-lg text-gray-700">
              While we excel in consulting, we're also passionate about direct innovation. We're developing our own technology solutions aimed at serving end consumers in segments that complement, rather than compete with, our clients' businesses. This deliberate approach ensures we maintain trust while pursuing innovation that adds value to the broader financial ecosystem.
            </p>
          </div>
        </div>

        {/* Commitment Section */}
        <div className="mb-24 bg-[#eee75c] text-[#00385c] rounded-tr-[40px] rounded-bl-[40px] p-8 md:p-12">
          <h2 className="text-3xl font-bold mb-6 text-center">Our Commitment</h2>
          <p className="text-lg mb-6">
            We pride ourselves on:
          </p>
          <ul className="text-lg mb-8 list-disc pl-6 space-y-3">
            <li>Delivering exceptional value to our consulting clients</li>
            <li>Developing ethical, non-competing innovations</li>
            <li>Maintaining clear boundaries between our service and product ventures</li>
            <li>Contributing positively to the consumer and financial services ecosystem</li>
          </ul>
          <p className="text-lg italic">
            At Novecta Solutions, we believe that responsible innovation and strategic consulting can coexist, creating value for all stakeholders while maintaining the highest standards of business ethics.
          </p>
        </div>

        {/* Team Section */}

        <div className="bg-white rounded-tr-[40px] rounded-bl-[40px] p-8 md:p-12 shadow-lg">
          <h2 className="text-3xl font-bold text-[#003B5C] text-center mb-12">Our Leadership</h2>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
            <TeamMember 
              name="Saurin Sanjanwala "
              role="Co-Founder"
              description="Seasoned professional with 19 years of experience in banking and fintech. Expert in launching credit products, managing P&Ls, and driving portfolio growth and monetization."
              imageUrl={saurinImage}
              linkedInUrl="https://www.linkedin.com/in/saurin-sanjanwala-a058a15/"
            />
            <TeamMember 
              name="Aashish Pareek"
              role="Co-Founder"
              description="Dynamic professional with 17+ years of experience in business growth and strategy. Expert in sales planning, project management, and transforming ideas into successful ventures."
              imageUrl={aashishImage}
              linkedInUrl="https://www.linkedin.com/in/aashishpareek/"
            />
          </div>
          </div>
        
      </div>
      
      <div className="flex justify-center mb-12 ">
        <CustomButton onClick={() => window.location.href = '/contact'}>
          Contact Us
        </CustomButton>
      </div>
    </div>
    
  );
};

export default AboutUs;